import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { v4 as uuid } from 'uuid';
import { ApplicationState } from '../../../types/api';
import { Candidate } from '../types';

export const ADD_CANDIDATE = 'ADD_CANDIDATE';
export const ADD_CANDIDATE_SUCCESS = 'ADD_CANDIDATE_SUCCESS';

export interface AddCandidate {
    type: typeof ADD_CANDIDATE;
    payload: {
        request: AxiosRequestConfig;
        vacancyId: string;
    };
}

export interface AddCandidateSuccess {
    type: typeof ADD_CANDIDATE_SUCCESS;
    payload: AxiosResponse<Candidate>;
    meta: {
        previousAction: {
            payload: {
                vacancyId: string;
            };
        };
    };
}

export const addCandidate = (vacancyId: string, firstname: string, lastname: string, email: string): AddCandidate => {
    const candidate: Candidate = {
        id: uuid(),
        firstname,
        lastname,
        email,
        applicationState: ApplicationState.CREATED
    };

    const addCandidateAction: AddCandidate = {
        type: ADD_CANDIDATE,
        payload: {
            request: {
                method: 'PUT',
                url: `/administrator/vacancies/${vacancyId}/candidates/${candidate.id}`,
                data: candidate
            },
            vacancyId
        }
    };

    return addCandidateAction;
};



// WEBPACK FOOTER //
// ./src/scenes/administrator/actions/add-candidate-action.ts